import { leagueAPIv2 } from './api';

const names = { matches: 'league-matches.csv', players: 'league-players.csv', comparison: 'league-comparison.csv' } as const;
const filename = (header: string | undefined, fallback: string): string => {
  const candidate = header?.match(/filename="([^"]+)"/i)?.[1]?.split(/[\\/]/).pop();
  return candidate && /^[a-zA-Z0-9][a-zA-Z0-9._-]{0,199}\.csv$/.test(candidate) ? candidate : fallback;
};

export const downloadLeagueExport = async (
  workspaceId: string,
  kind: keyof typeof names,
  query: object,
  signal: AbortSignal,
  currentWorkspace: () => string,
): Promise<void> => {
  const response = await leagueAPIv2.export(workspaceId, kind, query, signal);
  if (signal.aborted || currentWorkspace() !== workspaceId) return;
  const url = URL.createObjectURL(response.blob);
  const anchor = document.createElement('a');
  try {
    anchor.href = url;
    anchor.download = filename(response.disposition, names[kind]);
    anchor.hidden = true;
    document.body.appendChild(anchor);
    if (!signal.aborted && currentWorkspace() === workspaceId) anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
};
